import React from "react";
import banner from "../../assets/images/trustworthy-about-banner.jpg";

const PrivacyPolocy = () => {
  return (
    <>
      <section className="inner-banner">
        <img src={banner} alt="About Us Banner" className="inner-banner-img" />

        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>Privacy Policy</h1>

              <p>
                Best Home Servicing Company for Household Repairs or Servicing
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="privacy-policy py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="mb-3 text-center fw-bold">Privacy Policy</h1>
              <p>
                At <strong>Sevasati</strong>, accessible from our official
                website, protecting the privacy of our users is one of our top
                priorities. This Privacy Policy explains what information we
                collect, how we use it, and how we safeguard your data.
              </p>

              <p>
                If you have any questions or need more information regarding
                this Privacy Policy, please feel free to contact us.
              </p>

              <h2>Information We Collect</h2>
              <p>
                Like many websites, Sevasati uses standard log files. These
                files may collect information such as IP address, browser type,
                internet service provider (ISP), date and time stamps, referring
                pages, and clicks. This information is used only for analyzing
                trends, administering the site, and improving user experience.
                It is not linked to any personally identifiable information.
              </p>

              <h2>Cookies & Tracking Technologies</h2>
              <p>
                Sevasati may use cookies and similar technologies to enhance
                user experience, understand usage patterns, and improve our
                services. You can choose to disable cookies through your browser
                settings.
              </p>

              <h2>Third-Party Services</h2>
              <p>
                We may work with third-party tools or service providers for
                analytics, communication, or service delivery. These third
                parties may use cookies or similar technologies, and their
                privacy practices are governed by their respective privacy
                policies.
              </p>

              <p>
                Sevasati does not have control over cookies used by
                third-party websites or services.
              </p>

              <h2>Children’s Privacy</h2>
              <p>
                Sevasati is committed to protecting children’s privacy. We do
                not knowingly collect personal information from children under
                the age of 13. If you believe that a child has provided personal
                information on our platform, please contact us immediately and
                we will take appropriate action.
              </p>

              <h2>Online Privacy Policy Only</h2>
              <p>
                This Privacy Policy applies only to information collected
                through our website and online services. It does not apply to
                information collected offline or through other channels.
              </p>

              <h2>Consent</h2>
              <p>
                By using Sevasati’s website or services, you agree to this
                Privacy Policy and consent to the collection and use of
                information as described.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolocy;
